export default class {
  constructor() {}
  projectTypeSection() {
    const list = document.querySelector(".project__types__ul");
    if (!list) return;
    const items = list.querySelectorAll(".single__project__type__wrapper");
    const firstItem = items[0];

    // Add active class to first item by default
    firstItem.classList.add("is-active");

    // On hover of any item
    items.forEach((item) => {
      item.addEventListener("mouseenter", function () {
        // Remove active from first item
        firstItem.classList.remove("is-active");
        // Add active to current item
        items.forEach((i) => i.classList.remove("is-active"));
        this.classList.add("is-active");
      });
    });

    // On mouse leave from the entire list
    list.addEventListener("mouseleave", function () {
      items.forEach((i) => i.classList.remove("is-active"));
      // firstItem.classList.add('is-active');
    });
  }
}
